import React from 'react';
import ReactDOM from 'react-dom/client';
import './css-components/index.css';
import Mainapp from './mainapp';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
       <Mainapp/>
  </>
);


